import React, { useState, useEffect } from 'react';
import StripedTable from '../Table/StripedTable.jsx';

import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import { escapeEmptyDetail } from '../../utils/utils';
import {Button, Modal} from "semantic-ui-react";


const PayloadBuilderTable = (props) => {

  const payload = props.payload;
  
  const itemsPerPage = 5;
  const noOfPages = Math.ceil(payload?.length / itemsPerPage);
  const [page, setPage] = useState(1);
  const [headings, setHeadings] = useState([]);

  const [attributesModalOpen, setAttributesModalOpen] = useState(false);
  const [attributes, setAttributes] = useState([]);
  const [attributesHeadings, setAttributesHeadings] = useState([]);


  useEffect(() => {
    let headings = [];
    if (payload && payload[0] !== undefined) {
      for (const [key] of Object.entries(payload[0])) {
        headings.push(key);
      }

      headings.sort();
      setHeadings(headings);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const getElements = (pld) => {
    let elements = [];
    headings.forEach( el => {
      if (pld[el] && typeof pld[el] === 'object') {
        let aux =[];

        if(el === 'attributes') {
          elements.push(<span className='textlink' onClick={() => buildAttributesModalData(pld[el])}>Click to see reported data</span>)
        } else {
          for (const [key, value] of Object.entries(pld[el])) {
            aux.push(<p key={key}><b>{escapeEmptyDetail(key)}:</b> {escapeEmptyDetail(value)}</p>);
          }
          elements.push(aux);
        }
      } else elements.push(<p>{escapeEmptyDetail(pld[`${el}`])}</p>)
    })
    return elements;
  }

  const onAttributesModalClose = () => {
    setAttributesModalOpen(false);
  }

  const buildAttributesModalData = (attributes) => {
    setAttributes(attributes)
    let attrHeadings = [];
    if (attributes && attributes[0] !== undefined) {
      for (const [key] of Object.entries(attributes[0])) {
        attrHeadings.push(key);
      }

      attrHeadings.sort();
      setAttributesHeadings(attrHeadings);
    }

    setAttributesModalOpen(true);
  }

  return (
    <>
      <div style={{paddingTop: '10px'}} >
        <StripedTable
          headings={headings}
          rows={payload
          ?.slice(
            (page - 1) * itemsPerPage,
            page * itemsPerPage
          )
          .map((el) => {
            if (payload?.length) {
              return {
                elements: getElements(el)
              }
            } else {
              return {
                elements: [],
              }
            }
          })}
        />
        { noOfPages > 1 &&
          <Box
            component='div'
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '3rem 0'
            }}
            >
            <Pagination
              count={noOfPages}
              page={page}
              onChange={(e, page) => setPage(page)}
              defaultPage={1}
              color='primary'
              size='small'
            />
          </Box>
        }
      </div>
      <Modal
          open={attributesModalOpen}
          onClose={onAttributesModalClose}
          className='formModal'
      >
        <Modal.Header>Attributes</Modal.Header>
        <Modal.Content className='formModal-content'>
          <StripedTable
              headings={attributesHeadings}
              rows={attributes.map(el => {
                let elements = [];
                attributesHeadings.forEach( item => {
                   elements.push(<p key={item}>{escapeEmptyDetail(el[item])}</p>);
                 })
                 return {elements};
                })
              }
              />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onAttributesModalClose}>
            Close
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default PayloadBuilderTable